// src/housekeeping/housekeepingApi.ts
import { apiClient } from "@maat/api-base";
var housekeepingApi = {
  /** `housekeeping.view` + property access. `date` defaults to the property's local today. */
  getRoomStatusBoard: async (propertyId, params = {}) => {
    return apiClient.get(`/main/api/housekeeping/properties/${propertyId}/rooms`, { params });
  },
  /** `housekeeping.view`; workspace-wide, or one property's with `property_id`. */
  getAttention: async (params = {}) => {
    return apiClient.get("/main/api/housekeeping/attention", { params });
  },
  /** `housekeeping.update`: `dirty` or `clean`, plus an optional note (`null` clears it). */
  setRoomStatus: async (propertyId, unitId, payload) => {
    return apiClient.patch(
      `/main/api/housekeeping/properties/${propertyId}/rooms/${unitId}/status`,
      payload
    );
  },
  /** `housekeeping.inspect`: a clean room → `inspected`; a dirty one is a 409. */
  inspectRoom: async (propertyId, unitId) => {
    return apiClient.post(
      `/main/api/housekeeping/properties/${propertyId}/rooms/${unitId}/inspect`
    );
  },
  /** `housekeeping.assign`: one member (or `null`) onto 1–200 rooms; status untouched. */
  assignRooms: async (propertyId, payload) => {
    return apiClient.patch(
      `/main/api/housekeeping/properties/${propertyId}/rooms/assign`,
      payload
    );
  }
};

export {
  housekeepingApi
};
